import React from 'react';
import AppendixTemplate from '../../templates/AppendixTemplate';
import { useAppSelector } from '../../../redux/app/hooks';
import {
    selectLoginState,
} from '../../../redux/slices/loginSlice';
import { selectPaymentState } from '../../../redux/slices/paymentSlice';

export type AppendixPageProps = {
    children?: never;
};


const AppendixPage : React.FC<AppendixPageProps> = () => {
    const {
        isLogin,
        isSocialLogin,
        preferredUsername,
    } = useAppSelector(selectLoginState);

    const {
        isPaid,
    } = useAppSelector(selectPaymentState);

    // to_implement
    const profileImg = undefined;

    return (
        <AppendixTemplate
          isLogin={isLogin}
          isPaid={isPaid}
          isSocialLogin={isSocialLogin}
          profileImg={profileImg}
          preferredUsername={preferredUsername}
        />
    );
};

export default AppendixPage;
